module.exports = __webpack_public_path__ + "img/20220219_072619.232b3da1.jpg";